import { motion } from "framer-motion";
import { BedDouble, Bath, Building2, Receipt } from "lucide-react";
import { PROPERTY } from "@/data/property";
import SectionHeader, { EASE } from "@/components/SectionHeader";

const STATS = [
  { icon: BedDouble, label: "Bedrooms", value: "2" },
  { icon: Bath, label: "Bathrooms", value: "1.5" },
  { icon: Building2, label: "Type", value: "Condo Townhouse" },
  { icon: Receipt, label: "Taxes (2026)", value: "$2,606.72" },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};
const item = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
};

export default function Details() {
  return (
    <section id="residence" className="py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="The Residence"
          title="Easy living in Beechwood, Waterloo"
          sub={PROPERTY.description}
        />

        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.15 }}
          className="grid grid-cols-1 gap-6 md:grid-cols-6"
        >
          <motion.div
            variants={item}
            className="flex flex-col justify-between rounded-2xl border border-zinc-200 bg-white p-8 shadow-sm dark:border-zinc-800 dark:bg-zinc-900 md:col-span-6 lg:p-10"
          >
            <p className="font-serif text-2xl italic leading-snug text-zinc-800 dark:text-zinc-100 lg:text-3xl">
              “Unit 52 at 461 Beechwood Place — a comfortable condominium townhouse
              minutes from everything Waterloo is known for.”
            </p>
            <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
              {[
                { k: "Type", v: PROPERTY.specs.type },
                { k: "Property Tax (2026)", v: "$2,606.72" },
                { k: "Exterior Area", v: "1,077 sq ft" },
                { k: "Community", v: "Beechwood — Waterloo, ON" },
              ].map((s) => (
                <div key={s.k} className="border-t border-zinc-200 pt-4 dark:border-zinc-700">
                  <p className="text-xs uppercase tracking-[0.22em] text-zinc-500 dark:text-zinc-400">
                    {s.k}
                  </p>
                  <p className="mt-1 font-display text-lg font-semibold text-zinc-900 dark:text-white">
                    {s.v}
                  </p>
                </div>
              ))}
            </div>
          </motion.div>

          {STATS.map((h) => {
            const Icon = h.icon;
            return (
              <motion.div
                key={h.label}
                variants={item}
                className="flex flex-col justify-between rounded-2xl border border-zinc-200/80 bg-zinc-50 p-6 dark:border-zinc-800 dark:bg-zinc-900/60 md:col-span-3"
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-bronze/10 text-bronze">
                  <Icon size={20} />
                </span>
                <div className="mt-5">
                  <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 dark:text-zinc-400">
                    {h.label}
                  </p>
                  <p className="mt-1 font-display text-2xl font-bold text-zinc-900 dark:text-white">
                    {h.value}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
